// MEALUP browser tab (settings: "MEALUP: browser tab").
// While the visitor is on another tab, the title takes turns between the page title and short lines
// ("Храната ти изстива", or "Количката ти те чака" when the cart has items) and the icon blinks an orange dot.
// The cart count sits on the icon all the time when the cart is not empty. Everything goes back when the visitor returns.
(function () {
  const C = window.muTab;
  if (!C) return;
  const link = document.querySelector('link[rel="icon"]');
  const baseTitle = document.title;
  const baseIcon = link ? link.href : '';
  let img = null, count = C.count || 0, timer = null, step = 0;

  if (link && C.icon) {
    img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => setIcon(document.hidden && C.away ? 'dot' : null);
    img.src = C.icon;
  }

  // the icon with an orange circle: the cart count, or a plain dot when kind is 'dot' and the cart is empty
  function draw(kind) {
    const n = C.badge ? count : 0;
    if (!img || !img.complete || (!n && kind !== 'dot')) return baseIcon;
    try {
      const s = 64, c = document.createElement('canvas');
      c.width = c.height = s;
      const x = c.getContext('2d');
      x.drawImage(img, 0, 0, s, s);
      const r = n ? 19 : 14, cx = s - r, cy = r;
      x.beginPath(); x.arc(cx, cy, r + 3, 0, Math.PI * 2); x.fillStyle = '#fff'; x.fill();
      x.beginPath(); x.arc(cx, cy, r, 0, Math.PI * 2); x.fillStyle = '#EC7023'; x.fill();
      if (n) {
        x.fillStyle = '#fff';
        x.font = '800 ' + (n > 9 ? 22 : 28) + 'px system-ui, -apple-system, sans-serif';
        x.textAlign = 'center'; x.textBaseline = 'middle';
        x.fillText(n > 9 ? '9+' : String(n), cx, cy + 2);
      }
      return c.toDataURL('image/png');
    } catch (e) { return baseIcon; }
  }
  function setIcon(kind) { if (link) link.href = kind === 'base' ? baseIcon : draw(kind); }

  function lines() {
    const own = count > 0 && C.awayCart ? [C.awayCart] : (C.awayLines || []);
    return own.length ? own : [];
  }
  function tick() {
    const l = lines();
    if (!l.length) return;
    // even steps show a line, odd steps the page title, so the tab blinks between the two
    const on = step % 2 === 0;
    document.title = on ? l[(step / 2) % l.length] : baseTitle;
    setIcon(on ? 'dot' : (count ? null : 'base'));
    step++;
  }
  function away() {
    if (!C.away || timer) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then((r) => r.json()).then((cart) => { count = cart.item_count || 0; }).catch(() => {});
    step = 0;
    timer = setInterval(tick, Math.max(1, C.speed || 3) * 1000);
    setTimeout(tick, 400);
  }
  function back() {
    clearInterval(timer); timer = null;
    document.title = baseTitle;
    setIcon(null);
  }
  document.addEventListener('visibilitychange', () => (document.hidden ? away() : back()));
  // keep the count fresh after add to cart (Dawn's cart events, and our own add-to-cart fetch)
  document.addEventListener('cart:updated', (e) => { if (e.detail && typeof e.detail.item_count === 'number') { count = e.detail.item_count; setIcon(null); } });
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => { const n = ev && ev.cartData && ev.cartData.item_count; if (typeof n === 'number') { count = n; setIcon(null); } }); } catch (e) {}
  }
})();
